const EMAIL_TEMPLATE_MODE = {
  DESIGN_MANAGER: 'DESIGN_MANAGER',
  DRAG_AND_DROP: 'DRAG_AND_DROP'
};
export default EMAIL_TEMPLATE_MODE;